import type { App } from 'utils/app/types';

/**
 * Returns a function that determines if an event is of a type.
 */
export function is(eventType: string) {
  return function isType(event: App.Event): boolean {
    return eventType === event.type;
  };
}
